import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteServiceCategory } from 'API/ServiceCategories/deleteServiceCategory';

const useDeleteServiceCategory = (onSuccess, onError) => {
    const queryClient = useQueryClient();

    const deleteServiceCategoryById = async (serviceCategoryId) => {
        try {
            const response = await deleteServiceCategory(serviceCategoryId);
            return response.data;
        } catch (error) {
            console.error('Error deleting service category:', error);
            throw error;
        }
    };

    return useMutation({
        mutationFn: deleteServiceCategoryById,
        onSuccess: (data, serviceCategoryId) => {
            queryClient.invalidateQueries({ queryKey: ['ServiceCategories'] });
            queryClient.removeQueries({
                queryKey: ['ServiceCategory', serviceCategoryId],
            });
            if (onSuccess) {
                onSuccess(data);
            }
        },
        onError: (error) => {
            if (onError) {
                onError(error);
            }
        },
    });
};

export default useDeleteServiceCategory;
